import { Type } from 'class-transformer';
import {
  IsArray,
  IsNotEmptyObject,
  IsObject,
  ValidateNested,
} from 'class-validator';
import { SweetFaceTerminalFunctionsConfiguration } from '../../interface';

import { TerminalFunctions } from './save-sweet-face-terminal-functions.configuration.dto';

export class SaveSweetBulkFaceTerminalFunctionConfigurationDto {
  // @ApiProperty({ description: 'Terminal IDs' })
  @IsArray()
  @Type(() => Number)
  @ValidateNested({ each: true })
  terminalIds: number[];

  // @ApiProperty({ description: 'Terminal Functions' })
  @Type(() => TerminalFunctions)
  @ValidateNested({ each: true })
  @IsObject()
  @IsNotEmptyObject()
  functions: TerminalFunctions;

  private constructor(
    terminalIds: number[],
    functions: SweetFaceTerminalFunctionsConfiguration
  ) {
    this.terminalIds = terminalIds;
    this.functions = functions;
  }

  static create(input: {
    terminalIds: number[];
    functions: SweetFaceTerminalFunctionsConfiguration;
  }): SaveSweetBulkFaceTerminalFunctionConfigurationDto {
    return new SaveSweetBulkFaceTerminalFunctionConfigurationDto(
      input.terminalIds,
      input.functions
    );
  }
}
